// extracted by mini-css-extract-plugin
export default {"pageLoader":"PageLoader_pageLoader__JrnTr","loader":"PageLoader_loader__Q-M05","rotation":"PageLoader_rotation__i-Es+"};